import cn from "classnames";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import gitVersion from "src/_git_commit";
import "./styles.scss";

type Props = {
  className?: string;
};

const Version: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn("version_container", className)}>
      <p className="version">
        {t("version")}: {gitVersion.logMessage}
      </p>
    </div>
  );
};
export default Version;
